import {
  CollectionReference,
  DocumentData,
  DocumentReference,
  Query,
  QueryDocumentSnapshot,
  Timestamp,
  collection as defaultCollection,
  doc as defaultDoc,
} from "firebase/firestore";

import { db } from "./firestore";

export function converter<T>() {
  return {
    toFirestore: (data: T) => data,
    fromFirestore: (snap: QueryDocumentSnapshot) => snap.data() as T,
  };
}

export function collection<T extends DocumentData>(collectionName: string) {
  return defaultCollection(db, collectionName).withConverter(converter<T>());
}

export function parseCollectionReference<T extends DocumentData>(
  ref: CollectionReference<T> | Query<T> | string | null,
): CollectionReference<T> | Query<T> | null {
  if (typeof ref === "string") {
    return collection<T>(ref);
  }

  return ref;
}

export function doc<T extends DocumentData>(docName: string) {
  return defaultDoc(db, docName).withConverter(converter<T>());
}

export function parseDocumentReference<T extends DocumentData>(
  ref: DocumentReference<T> | string | null,
): DocumentReference<T> | null {
  if (typeof ref === "string") {
    return doc<T>(ref);
  }

  return ref;
}

export function getRandomTimestampInRange(startDate: Date, endDate: Date): Timestamp {
  const startMillis = startDate.getTime();
  const endMillis = endDate.getTime();
  const randomMillis = startMillis + Math.random() * (endMillis - startMillis);
  return Timestamp.fromMillis(randomMillis);
}
